import type { HeldItem } from "./types";

const heldItems: HeldItem[] = [
  { id: "aeos-cookie", image: "held-items/aeos-cookie.png", name: "Aeos Cookie" },
  { id: "attack-weight", image: "held-items/attack-weight.png", name: "Attack Weight" },
  { id: "special-attack-specs", image: "held-items/special-attack-specs.png", name: "Sp. Atk Specs" },
  { id: "shell-bell", image: "held-items/shell-bell.png", name: "Shell Bell" },
  { id: "float-stone", image: "held-items/float-stone.png", name: "Float Stone" },
  { id: "muscle-band", image: "held-items/muscle-band.png", name: "Muscle Band" },
  { id: "scope-lens", image: "held-items/scope-lens.png", name: "Scope Lens" },
  { id: "wise-glasses", image: "held-items/wise-glasses.png", name: "Wise Glasses" },
  { id: "leftovers", image: "held-items/leftovers.png", name: "Leftovers" },
  { id: "exp-share", image: "held-items/exp-share.png", name: "Exp. Share" },
  { id: "focus-band", image: "held-items/focus-band.png", name: "Focus Band" },
  { id: "energy-amplifier", image: "held-items/energy-amplifier.png", name: "Energy Amplifier" },
  { id: "buddy-barrier", image: "held-items/buddy-barrier.png", name: "Buddy Barrier" },
  { id: "score-shield", image: "held-items/score-shield.png", name: "Score Shield" },
  { id: "assault-vest", image: "held-items/assault-vest.png", name: "Assault Vest" },
  { id: "rocky-helmet", image: "held-items/rocky-helmet.png", name: "Rocky Helmet" },
  { id: "razor-claw", image: "held-items/razor-claw.png", name: "Razor Claw" },
  { id: "choice-specs", image: "held-items/choice-specs.png", name: "Choice Specs" },
  { id: "weakness-policy", image: "held-items/weakness-policy.png", name: "Weakness Policy" },
  { id: "rapid-fire-scarf", image: "held-items/rapid-fire-scarf.png", name: "Rapid-Fire Scarf" },
  { id: "drain-crown", image: "held-items/drain-crown.png", name: "Drain Crown" },
  { id: "slick-spoon", image: "held-items/slick-spoon.png", name: "Slick Spoon" },
  { id: "rescue-hood", image: "held-items/rescue-hood.png", name: "Rescue Hood" },
  { id: "curse-bangle", image: "held-items/curse-bangle.png", name: "Curse Bangle" },
  { id: "curse-incense", image: "held-items/curse-incense.png", name: "Curse Incense" },
  { id: "charging-charm", image: "held-items/charging-charm.png", name: "Charging Charm" },
  { id: "resonant-guard", image: "held-items/resonant-guard.png", name: "Resonant Guard" },
  { id: "drive-lens", image: "held-items/drive-lens.png", name: "Drive Lens" },
  { id: "accel-bracer", image: "held-items/accel-bracer.png", name: "Accel Bracer" },
  { id: "amulet-coin", image: "held-items/amulet-coin.png", name: "Amulet Coin" },
  { id: "choice-scarf", image: "held-items/choice-scarf.png", name: "Choice Scarf" },
  { id: "big-root", image: "held-items/big-root.png", name: "Big Root" },
  { id: "tenacity-belt", image: "held-items/tenacity-belt.png", name: "Tenacity Belt" },
  { id: "vanguard-bell", image: "held-items/vanguard-bell.png", name: "Vanguard Bell" },
  { id: "rusted-sword", image: "held-items/rusted-sword.png", name: "Rusted Sword", exclusive: "Zacian" },
  { id: "mewtwonite-x", image: "held-items/mewtwonite-x.png", name: "Mewtwonite X", exclusive: "Mewtwo" },
  { id: "mewtwonite-y", image: "held-items/mewtwonite-y.png", name: "Mewtwonite Y", exclusive: "Mewtwo" },
  { id: "lucarionite", image: "held-items/lucarionite.png", name: "Lucarionite", exclusive: "Lucario" },
  { id: "charizardite-x", image: "held-items/charizardite-x.png", name: "Charizardite X", exclusive: "Charizard" },
  { id: "charizardite-y", image: "held-items/charizardite-y.png", name: "Charizardite Y", exclusive: "Charizard" },
  { id: "gyaradosite", image: "held-items/gyaradosite.png", name: "Gyaradosite", exclusive: "Gyarados" },
];

export default heldItems;
